<template>
  <div id="wrapper" v-if="sectionInfo && isVisible" v-on-display="{sectionInfo, context: this}">
    <div class="inner-wrap">
      <div class="title">
        <h1 v-band-title class="title-area" tabindex="0">
          <span class="label">{{multiSectionTitle}}</span>
        </h1>
      </div>
      <div class="band-board-content">
        <ul class="player-field-list">
          <li>
            <player-rank section="타율" :rank-list="battingAverageList"></player-rank>
          </li>
          <li>
            <player-rank section="홈런" :rank-list="homeRunList"></player-rank>
          </li>
          <li>
            <player-rank section="타점" :rank-list="runBattedInList"></player-rank>
          </li>
          <li>
            <player-rank section="평균 자책" :rank-list="earnedRunAverageList"></player-rank>
          </li>
          <li>
            <player-rank section="다승" :rank-list="totalWinCounterList"></player-rank>
          </li>
          <li>
            <player-rank section="탈삼진" :rank-list="strikeOutList"></player-rank>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import { bandTitle, onDisplay } from '@/common/resources/directives'
  import { fetchOnContent } from '@/common/utils/request.common'
  import MultiSectionMixin from '@/mixins/multisection.mixin'
  import PlayerRank from '@/components/kbo/PlayerRank'
  import { getHitterRanking, getPitcherRanking, decimalPoint } from '@/common/utils/baseball'
  import _ from 'lodash'
  export default {
  name: 'TemplateKboPlayerRank',
  components: {
    PlayerRank
  },
  mixins: [
    MultiSectionMixin
  ],
  props: {
    sectionInfo: {
      type: Object
    }
  },
  directives: {
    onDisplay,
    bandTitle
  },
  data () {
    return {
      battingAverageList: [],
      homeRunList: [],
      runBattedInList: [],
      earnedRunAverageList: [],
      totalWinCounterList: [],
      strikeOutList: [],
      isLoading: false
    }
  },
  methods: {
    async fetchData () {
      try {
        return await fetchOnContent(this.sectionInfo)
      } catch (e) {}
    },
    setData (response) {
      function getTop5 (rankList = []) {
        return playerImg(rankList.slice(0, 5))
      }
      function playerImg (list) {
        list.forEach((item) => {
          if (_.get(item, 'image', '') === '' || _.get(item, 'image', '') === 'null' || _.get(item, 'image', '') === null) {
            _.set(item, 'image', require('../../../assets/images/kbo/img-default-kbo-1.png'))
          }
        })
        return list
      }
      function battingAvgConvert (hitter) {
        const hitterValue = decimalPoint(Number(hitter.value), 3).length < 5
          ? Number(hitter.value).toFixed(3)
          : decimalPoint(Number(hitter.value), 3)
        hitter.value = String(hitterValue)
        return hitter
      }
      function earnedRunAverageConvert (pitcher) {
        const pitcherValue = decimalPoint(Number(pitcher.value), 3).length < 5
          ? Number(pitcher.value).toFixed(3)
          : decimalPoint(Number(pitcher.value), 3)
        pitcher.value = pitcherValue
        return pitcher
      }
      function totalWinCounterConvert (pitcher) {
        pitcher.value = pitcher.value + '승'
        return pitcher
      }
      /* eslint-disable camelcase */
      const { batting_average, home_run, run_batted_in } = getHitterRanking(response)
      const { earned_run_average, strike_out, total_win_counter } = getPitcherRanking(response)
      this.battingAverageList = getTop5(batting_average).map(battingAvgConvert)
      this.homeRunList = getTop5(home_run)
      this.runBattedInList = getTop5(run_batted_in)
      this.earnedRunAverageList = getTop5(earned_run_average).map(earnedRunAverageConvert)
      this.strikeOutList = getTop5(strike_out)
      this.totalWinCounterList = getTop5(total_win_counter).map(totalWinCounterConvert)
      /* eslint-enable camelcase */
    },
    async init () {
      this.isLoading = true
      const response = await this.fetchData()
      this.setData(response)
      this.isLoading = false
    }
  },
  computed: {
    isVisible () {
      return !this.isLoading
    }
  },
  created () {
    this.init()
  }

}
</script>
